import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const WhoWeAre = () => {
  // Trigger animation only when section is visible
  const { ref, inView } = useInView({
    triggerOnce: true, // run once per page load
    threshold: 0.2, // 20% of section visible
  });

  return (
    <section ref={ref} className="w-full bg-white py-16 px-6 md:px-12 lg:px-20">
      {/* Title & Description */}
      <div className="text-center max-w-3xl mx-auto mb-12">
        <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-[#E43038]">
          Who We Are ?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          At 4 Aviators, we combine precision training, advanced simulators, and expert mentorship 
          to prepare you for a successful aviation career.
        </p>
      </div>

      {/* 2 Halves Section */}
      <div className="flex flex-col md:flex-row items-center gap-10 mb-16">
        {/* Left Content */}
        <div className="flex-1 text-gray-700 space-y-5 text-base sm:text-lg leading-relaxed">
          <p>
            4 Aviators Aviation Academy is a premier flight training institution dedicated to excellence 
            in aviation education. Since our founding in 2008, we've been committed to providing comprehensive, 
            professional flight training that prepares students for successful careers in aviation.
          </p>

          <p>
            Our academy stands out through our modern fleet of well-maintained aircraft, 
            state-of-the-art simulators, and a team of highly experienced, certified flight instructors. 
            We offer a range of programs from Private Pilot License (PPL) to Commercial Pilot License (CPL) and beyond.
          </p>

          <p>
            What sets us apart is our personalized approach to training. We understand that every student 
            has unique goals and learning styles. Our instructors work closely with each student to create 
            customized training plans that ensure success while maintaining the highest safety standards in the industry.
          </p>
        </div>

        {/* Right Image */}
        <div className="flex-1 w-full">
          <img
            src="https://mhcockpit.com/Media/4%20Aviators/About/4-aviators-who-we-are.jpg"
            alt="4 Aviators Academy"
            className="rounded-2xl shadow-lg object-cover"
          />
        </div>
      </div>

      {/* CountUp Stats */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
        <div>
          <h3 className="text-4xl font-bold text-[#E43038]">
            {inView && <CountUp end={15} duration={2.5} />}+
          </h3>
          <p className="text-gray-700 mt-2 font-medium">Years of Excellence</p>
        </div>
        <div>
          <h3 className="text-4xl font-bold text-[#E43038]">
            {inView && <CountUp end={500} duration={2.5} />}+
          </h3>
          <p className="text-gray-700 mt-2 font-medium">Certified Pilots</p>
        </div>
        <div>
          <h3 className="text-4xl font-bold text-[#E43038]">
            {inView && <CountUp end={150} duration={2.5} />}+
          </h3>
          <p className="text-gray-700 mt-2 font-medium">Modern Aircraft</p>
        </div>
        <div>
          <h3 className="text-4xl font-bold text-[#E43038]">
            {inView && <CountUp end={100} duration={2.5} />}%
          </h3>
          <p className="text-gray-700 mt-2 font-medium">Safety Record</p>
        </div>
      </div>
    </section>
  );
};

export default WhoWeAre;
